import React, {useState} from 'react';
import {useHistory} from "react-router-dom";
import messages from "res/messages/farsi";
import Space from "../../../components/space/Space";
import IconTitleValue from "../../../components/textValue/IconTitleValue";

import ICLogo from "res/images/logo_4.png";
import {IsSM_M_F} from "my-styles/media/media";

export default function OrderProduct(props) {

    const history = useHistory()
    const product = props.product

    const [defaultSrc, setDefaultSrc] = useState(undefined)

    function onProductClick() {
        props.onNavigate(history, "/productDetail?v=" + product.product_id)
    }

    return (
        <div className="fullWidth">
            {product && !product.isTemp &&
            <div
                style={{height: "90%"}}
                className={IsSM_M_F() ?
                    "card marginTopSmall marginRightMedium horizontalScreen" :
                    "card marginSmall horizontalScreen"
                }
                onClick={onProductClick}>
                <div>
                    <img
                        className="marginSmall"
                        style={{height: "5em"}}
                        src={defaultSrc ? defaultSrc : product.image}
                        onError={() => {
                            setDefaultSrc(ICLogo)
                        }}
                        alt=""/>
                </div>
                <div className="marginSmall">
                    <div className="mediumTextBold">
                        {product.name}
                    </div>
                    <Space/>
                    <IconTitleValue
                        title={messages.productCount}
                        titleClassName="mediumText"
                        value={product.quantity}
                        valueClassName="grayColor mediumTextBold greenColor_2"/>
                    <IconTitleValue
                        title={messages.totalPrice}
                        titleClassName="mediumText"
                        value={(product.price_price * product.quantity).toLocaleString() + " " + messages.priceUnit}
                        valueClassName="grayColor mediumTextBold"/>
                    {product.special_price > 0 &&
                    <IconTitleValue
                        title={messages.discount}
                        titleClassName="mediumText redColor"
                        value={((product.price_price * product.quantity) -
                            (product.special_price * product.quantity)).toLocaleString() + " " + messages.priceUnit
                        }
                        valueClassName="redColor mediumTextBold"/>
                    }
                </div>
            </div>
            }
        </div>
    )

}